"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DefaultBrandContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _defaultPanelConfigurations = require("./quoteTools/defaultPanelConfigurations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var DefaultBrandContext = exports.DefaultBrandContext = {
  brand: {
    key: 'classic',
    products: 'pinscom',
    title: 'Classic',
    fullName: 'PetSure',
    shortName: 'PetSure',
    homeUrl: 'https://www.petsure.com.au',
    cssUrls: null,
    logos: [{
      key: 'logo',
      imageUrl: '',
      redirectUrl: '/',
      imageTitle: 'Get a pet insurance quote',
      imageTitleDescription: 'Provided by PetSure - Australia\'s leading Pet Insurance provider'
    }],
    supportPhoneNumber: '1300 855 663',
    supportEmailAddress: 'petsure@petsure.com.au',
    partner: 'PINSCOM',
    marketingPartner: 'PetSure',
    broker: 'PICA',
    favIconUrl: 'https://petsure.com.au/wp-content/uploads/2020/01/cropped-favicon-32x32.png',
    partnerPrefix: 'PC',
    gtmId: 'PXL4RP',
    gtmDataLayer: 'dataLayer'
  },
  promos: {},
  seo: {
    title: 'PetSure. For a life with pets.',
    description: 'Just as many of us put pets at the centre of our lives, we put the welfare of pets at the heart of our business.'
  },
  marketing: {
    adFixus: true
  },
  tracking: [{
    provider: 'GoogleAnalytics',
    key: 'gtmKey',
    keyValue: 'GTM-P6HNPK'
  }],
  layout: {
    bodyCssClass: 'PetSureUILibrary',
    header: {
      pageTitleText: '',
      customContent: null,
      customCssClass: '',
      headerShouldPin: true,
      contactDetails: null
    },
    main: {
      heading: {
        headingText: 'Your pet\'s details',
        headingSecondaryText: '',
        mandatoryText: 'Mandatory fields'
      }
    },
    footer: {
      customContent: null,
      customCssClass: '',
      socialLinks: [{
        icon: 'facebook',
        label: 'PetSure Facebook Site',
        url: 'https://www.facebook.com/PetSureAustralia',
        svg: /*#__PURE__*/_react["default"].createElement(_components.FacebookSvg, null)
      }, {
        icon: 'instagram',
        label: 'PetSure Instagram Site',
        url: 'https://www.instagram.com/petsure_australia',
        svg: /*#__PURE__*/_react["default"].createElement(_components.InstagramSvg, null)
      }, {
        icon: 'linkedin',
        label: 'PetSure LinkedIn Site',
        url: 'https://www.linkedin.com/company/petsure',
        svg: /*#__PURE__*/_react["default"].createElement(_components.LinkedInSvg, null)
      }],
      copyright: /*#__PURE__*/_react["default"].createElement(_components.PetSureCopyright, null),
      customDisclosure: {
        brand: {
          link: 'https://www.petinsurance.com.au',
          label: 'Petinsurance.com.au'
        },
        tmd: {
          link: 'https://www.petinsurance.com.au',
          label: 'petinsurance.com.au'
        },
        authorisedRepresentative: 'PetSure’s Authorised Representative (AR) Pet Insurance Pty Ltd ABN 38 607 160 930, AR 1234944 (PIPL) and PIPL’s authorised distribution partners',
        footerDisclaimer: function footerDisclaimer(props) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "This policy is issued by PetSure (Australia) Pty Ltd ABN 95 075 949 923, AFSL 420183 (PetSure) and promoted and distributed by PetSure\u2019s Authorised Representative (AR) Pet Insurance Pty Ltd ABN 38 607 160 930, AR 1234944 (PIPL) and PIPL\u2019s authorised distribution partners. Any advice provided is general only and does not take into account your individual objectives, financial situation or needs. Please consider the Product Disclosure Statement (PDS) to ensure this product meets your needs before purchasing. PDS and Target Market Determination available at ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.tmd.link,
            ref: props.disclaimerLink
          }, props.tmd.label), ".");
        },
        expireDate: '2024-03-31',
        discount: 50,
        hasGapOnly: true,
        hasPetScripts: true,
        hasVetChat: false,
        myPetPass: {
          hasMyPetPass: true,
          eligibilityWordings: 'Available only to holders of active pet insurance policies of participating brands administered by PetSure'
        }
      },
      footerSections: [{
        'heading': 'About Us',
        'links': [{
          'label': 'Careers',
          'url': 'https://petsure.com.au/about-petsure/careers/'
        }, {
          'label': 'Community',
          'url': 'https://petsure.com.au/community/'
        }, {
          'label': 'Partners',
          'url': 'https://petsure.com.au/partners/'
        }, {
          'label': 'People',
          'url': 'https://petsure.com.au/our-petsurepeople/'
        }]
      }, {
        'heading': 'Services',
        'links': [{
          'label': "GapOnly\u2122",
          'url': 'https://petsure.com.au/gaponly/'
        }, {
          'label': 'Webinars',
          'url': 'https://petsure.com.au/webinars/'
        }]
      }, {
        'heading': 'Legal',
        'links': [{
          'label': 'Accessibility Services',
          'url': 'https://petsure.com.au/accessibilityservices/'
        }, {
          'label': 'Code of Conduct',
          'url': 'https://petsure.com.au/wp-content/uploads/2019/12/PetSureCodeOfConduct-041219.pdf'
        }, {
          'label': 'Complaints Process',
          'url': 'https://petsure.com.au/our-complaints-process/'
        }, {
          'label': 'Disclaimer',
          'url': 'https://petsure.com.au/disclaimer/'
        }, {
          'label': 'Family Violence Policy',
          'url': 'http://petsure.com.au/wp-content/uploads/2020/06/PetSure-Family-Violence-Policy-160620.pdf'
        }, {
          'label': 'Financial Hardship Support',
          'url': 'http://petsure.com.au/wp-content/uploads/2021/10/Financial-Hardship-PDF-for-website.pdf'
        }, {
          'label': 'Financial Services Guide',
          'url': 'https://petsure.com.au/fsg/'
        }, {
          'label': 'General Insurance Code of Practice',
          'url': 'https://petsure.com.au/general-insurance-code-of-practice-code/'
        }, {
          'label': 'Privacy Policy',
          'url': 'https://petsure.com.au/wp-content/uploads/2019/12/PetSure-Privacy-Policy-HRM-POL-036-.pdf'
        }, {
          'label': 'Product Design Philosophy',
          'url': 'https://petsure.com.au/product-design-philosophy/'
        }]
      }, {
        heading: 'Contact Us',
        content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
          href: "tel://+61 (02) 9842 4800"
        }, "+61 (02) 9842 4800"), /*#__PURE__*/_react["default"].createElement("p", null, "Locked Bag No. 9021", /*#__PURE__*/_react["default"].createElement("br", null), "Castle Hill NSW 1765"), /*#__PURE__*/_react["default"].createElement("p", null, "Level 1, 465 Victoria Avenue", /*#__PURE__*/_react["default"].createElement("br", null), "Chatswood, NSW 2067"), /*#__PURE__*/_react["default"].createElement("p", null, "Vet-to-vet helpline", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("a", {
          href: "tel://1300 838 457"
        }, "1300 838 457"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("a", {
          href: "mailto:vethelpline@petsure.com.au"
        }, "vethelpline@petsure.com.au")))
      }]
    },
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "DefaultCampaign1",
        customCssClass: "DefaultCampaign1",
        campaignImageDescription: "GapOnly ready Pet Insurance",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/GapOnly_tile_232x200.png");
        },
        __type: "CampaignHolder"
      })]
    }
  },
  panelConfigurations: _defaultPanelConfigurations.DefaultPanelConfigurations
};
var _default = exports["default"] = {
  DefaultBrandContext: DefaultBrandContext
};